<template>
  <div class="cascadas cascadas-register">
    <div class="register-hero">
      <span class="register-hero__brand">XHIDENXI</span>
      <h1 class="register-hero__title">RETO ENTRE CASCADAS</h1>
      <p class="register-hero__sub">Formulario de inscripción &middot; 13 de diciembre, 2026</p>
    </div>

    <div class="register-wrap">
      <form @submit.prevent="submitRegistration" novalidate :class="{ 'was-validated': validated }" class="register-ticket">
        <div class="register-ticket__notch register-ticket__notch--left" aria-hidden="true"></div>
        <div class="register-ticket__notch register-ticket__notch--right" aria-hidden="true"></div>

        <!-- Selector de reto: distancia -->
        <div class="mb-5 text-center">
          <span class="field-label field-label--center">Selecciona tu reto</span>

          <div class="distance-toggle">
            <input type="radio" class="btn-check" name="distancia" id="distancia5k" value="5K" v-model="formData.distancia">
            <label class="distance-toggle__btn" for="distancia5k">
              <span class="distance-toggle__km">5K</span>
              <span class="distance-toggle__time">Salida 8:00 a.m.</span>
            </label>

            <input type="radio" class="btn-check" name="distancia" id="distancia10k" value="10K" v-model="formData.distancia">
            <label class="distance-toggle__btn" for="distancia10k">
              <span class="distance-toggle__km">10K</span>
              <span class="distance-toggle__time">Salida 8:10 a.m.</span>
            </label>
          </div>
        </div>

        <div v-if="formData.distancia !== ''">

          <!-- Datos del participante -->
          <section class="mb-4">
            <h4 class="section-title">Datos del participante</h4>

            <div class="row g-3">
              <div class="col-md-9">
                <label class="field-label">Nombre completo</label>
                <input v-model="formData.nombre" type="text" class="form-control"
                  placeholder="Escribe tu nombre completo" required>
                <div class="invalid-feedback">Por favor, ingresa el nombre.</div>
              </div>

              <div class="col-md-3">
                <label class="field-label">Edad</label>
                <input v-model="formData.edad" type="text" inputmode="numeric" class="form-control" placeholder="Ej: 25"
                  @input="formData.edad = formData.edad.replace(/\D/g, '').slice(0, 2)" required>
                <div class="invalid-feedback">Ingresa tu edad.</div>
              </div>

              <div class="col-md-6">
                <label class="field-label">Teléfono</label>
                <input v-model="formData.telefono" type="tel" class="form-control"
                  placeholder="10 dígitos"
                  @input="formData.telefono = formData.telefono.replace(/\D/g, '').slice(0, 10)" required>
                <div class="invalid-feedback">Ingresa un teléfono válido.</div>
              </div>

              <div class="col-md-6">
                <label class="field-label">Correo electrónico</label>
                <input v-model="formData.email" type="email" class="form-control"
                  placeholder="tucorreo@ejemplo.com" required>
                <div class="invalid-feedback">Ingresa un correo válido.</div>
              </div>

              <div class="col-md-12">
                <label class="field-label">Localidad, municipio y estado</label>
                <input v-model="formData.ubicacion" type="text" class="form-control"
                  placeholder="Ej: Jilotepec, Edo. Méx." required>
                <div class="invalid-feedback">Por favor, ingresa tu ubicación.</div>
              </div>

              <div class="col-md-12">
                <label class="field-label">Contacto de emergencia</label>
                <input v-model="formData.emergencia" type="text" class="form-control"
                  placeholder="Nombre - 5512345678" required>
                <div class="invalid-feedback">Ingresa un contacto de emergencia.</div>
              </div>

              <!-- Género -->
              <div class="col-12">
                <label class="field-label">Categoría / género</label>

                <div class="gender-group">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="genero" id="radioM" value="Mujer"
                      v-model="formData.genero" required>
                    <label class="form-check-label" for="radioM">Mujer &mdash; Libre Femenil</label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="genero" id="radioH" value="Hombre"
                      v-model="formData.genero" required>
                    <label class="form-check-label" for="radioH">Hombre &mdash; Libre Varonil</label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="genero" id="radioO" value="Otro"
                      v-model="formData.genero" required>
                    <label class="form-check-label" for="radioO">Otro</label>
                  </div>
                </div>

                <div v-if="formData.genero === 'Otro'" class="mt-2">
                  <input type="text" class="form-control" placeholder="Escríbelo aquí (opcional)"
                    v-model="otroGenero">
                </div>

                <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.genero }">
                  Por favor selecciona una opción.
                </div>
              </div>

              <div class="col-12">
                <label class="field-label">Talla de playera</label>
                <select class="form-select" v-model="formData.tallaCamisa" required>
                  <option selected disabled value="">Selecciona una talla</option>
                  <option value="XS">XS (Extra chica)</option>
                  <option value="S">S (Chica)</option>
                  <option value="M">M (Mediana)</option>
                  <option value="L">L (Grande)</option>
                  <option value="XL">XL (Extra grande)</option>
                </select>
                <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.tallaCamisa }">
                  Por favor selecciona una talla.
                </div>
              </div>
            </div>

            <Transition name="fade">
              <div v-if="formData.distancia && formData.genero" class="category-preview">
                Vas a correr <strong>{{ formData.distancia }}</strong> en la categoría
                <strong>{{ formData.genero === 'Mujer' ? 'Libre Femenil' : formData.genero === 'Hombre' ? 'Libre Varonil' : 'Libre' }}</strong>
              </div>
            </Transition>
          </section>

          <!-- Menores de edad -->
          <Transition name="fade">
            <section v-if="esMenorDeEdad" class="minor-box">
              <span class="minor-box__tag">Menor de edad</span>
              <h4 class="minor-box__title">Necesitamos una responsiva firmada</h4>
              <p>
                Detectamos que el participante es menor de edad. Para poder inscribirse, un padre, madre o tutor
                debe firmar una responsiva y entregarla antes o el día del evento.
              </p>
              <a href="https://wa.me/525540861907?text=Hola%2C%20necesito%20la%20responsiva%20para%20un%20menor%20de%20edad"
                target="_blank" class="minor-box__link">
                Solicitar responsiva por WhatsApp &rarr;
              </a>

              <div class="form-check mt-3">
                <input class="form-check-input" type="checkbox" id="aceptaResponsiva"
                  v-model="formData.aceptaResponsivaMenor" required>
                <label class="form-check-label" for="aceptaResponsiva">
                  Confirmo que un padre, madre o tutor firmará la responsiva y la entregaré antes o el día del evento.
                </label>
                <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.aceptaResponsivaMenor }">
                  Debes confirmar este punto para continuar.
                </div>
              </div>
            </section>
          </Transition>

          <!-- Deslinde de responsabilidad -->
          <section class="waiver-box">
            <span class="waiver-box__tag">Antes de continuar</span>
            <h4 class="waiver-box__title">Aviso de riesgo y responsabilidad</h4>
            <p>
              Un reto trail se corre sobre senderos, piedra, lodo y cruces de agua, y puede implicar caídas,
              golpes u otras lesiones. Antes de inscribirte, confirma que participas de forma voluntaria y
              consciente de estas condiciones.
            </p>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="aceptaDeslinde"
                v-model="formData.aceptaDeslinde" required>
              <label class="form-check-label" for="aceptaDeslinde">
                Declaro que participo por voluntad propia, que cuento con condición física adecuada y que
                deslindo a XHIDENXI y a Las Cascadas de cualquier responsabilidad por lesiones derivadas de
                mi participación en el Reto Entre Cascadas 2026.
              </label>
              <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.aceptaDeslinde }">
                Debes aceptar el aviso de responsabilidad para inscribirte.
              </div>
            </div>
          </section>

          <!-- Acompañantes (opcional) -->
          <section class="mb-4 pt-3 section-divider">
            <h4 class="section-title">Acompañantes (opcional)</h4>
            <p class="companion-intro mt-1">
              Si alguien te acompañará al lugar (sin correr), regístralo aquí.
            </p>

            <div class="companion-prices">
              <span class="companion-prices__item">Solo el día del evento <strong>$150</strong> <small>/persona</small></span>
              <span class="companion-prices__item">Si se queda a acampar <strong>$250</strong> <small>/persona</small></span>
            </div>

            <div class="row g-3">
              <div class="col-md-12">
                <label class="field-label">Número de acompañantes</label>
                <select id="formCantidadAcom" class="form-select" v-model="formCantidadAcom">
                  <option value="0">Sin acompañantes</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="Otra cantidad">Otra cantidad</option>
                </select>

                <div v-if="formCantidadAcom === 'Otra cantidad'" class="mt-3">
                  <input type="number" min="1" class="form-control" placeholder="Ingresa la cantidad deseada"
                    v-model="formCantidadAcomOtra">
                </div>
              </div>
            </div>

            <Transition name="fade">
              <div v-if="acomList.length > 0" class="mt-3">
                <label class="field-label">¿Tus acompañantes se quedarán a acampar?</label>
                <div class="companion-mode-toggle">
                  <input type="radio" class="btn-check" name="modalidadAcom" id="modalidadDia" value="dia" v-model="modalidadAcompanantes">
                  <label class="companion-mode-toggle__btn" for="modalidadDia">
                    Solo el día <span>$150 / persona</span>
                  </label>

                  <input type="radio" class="btn-check" name="modalidadAcom" id="modalidadCamping" value="camping" v-model="modalidadAcompanantes">
                  <label class="companion-mode-toggle__btn" for="modalidadCamping">
                    Se quedan a acampar <span>$250 / persona</span>
                  </label>
                </div>
              </div>
            </Transition>

            <Transition name="fade">
              <div v-if="acomList.length > 0" class="companion-total">
                {{ acomList.length }} acompañante{{ acomList.length > 1 ? 's' : '' }}
                &middot; {{ modalidadAcompanantes === 'camping' ? 'con camping' : 'solo el día' }}
                &middot; total acompañantes: <strong>${{ acomList.length * costoUnitarioAcompanante }}</strong>
              </div>
            </Transition>

            <TransitionGroup name="fade">
              <div v-for="(acom, index) in acomList" :key="index" class="companion-card">
                <span class="companion-card__index">Acompañante {{ index + 1 }}</span>

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="field-label">Nombre completo</label>
                    <input type="text" class="form-control" v-model="acom.nombre"
                      placeholder="Nombre del acompañante" required>
                    <div class="invalid-feedback">Ingresa el nombre del acompañante.</div>
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Edad</label>
                    <input type="text" inputmode="numeric" class="form-control" v-model="acom.edad"
                      placeholder="Ej: 30"
                      @input="acom.edad = acom.edad.replace(/\D/g, '').slice(0, 3)" required>
                    <div class="invalid-feedback">Ingresa la edad.</div>
                  </div>
                  <div class="col-md-3">
                    <label class="field-label">Teléfono</label>
                    <input type="tel" class="form-control" v-model="acom.telefono"
                      placeholder="10 dígitos"
                      @input="acom.telefono = acom.telefono.replace(/\D/g, '').slice(0, 10)" required>
                    <div class="invalid-feedback">Ingresa un teléfono.</div>
                  </div>
                </div>
              </div>
            </TransitionGroup>
          </section>

          <!-- Información de pago -->
          <section class="mb-4 pt-3 section-divider">
            <h4 class="section-title">Información de pago y grupo</h4>

            <div class="row g-3">
              <div class="col-md-12">
                <label class="field-label">¿Perteneces a algún grupo de corredores? (opcional)</label>
                <input v-model="formData.grupo" type="text" class="form-control" placeholder="Ej: Grupo X">
              </div>
              <div class="col-md-6">
                <label class="field-label">Monto pagado</label>
                <div class="input-group">
                  <span class="input-group-text">$</span>
                  <input v-model="formData.pagoMonto" type="number" class="form-control" required>
                </div>
                <div class="invalid-feedback">Ingresa el monto pagado.</div>
                <p v-if="acomList.length > 0" class="companion-hint">
                  Recuerda incluir ${{ acomList.length * costoUnitarioAcompanante }} de acompañante{{ acomList.length > 1 ? 's' : '' }}
                  ({{ modalidadAcompanantes === 'camping' ? 'con camping' : 'solo el día' }}) en tu monto pagado.
                </p>
              </div>
              <div class="col-md-6">
                <label class="field-label">Fecha de pago</label>
                <input v-model="formData.pagoFecha" type="date" class="form-control" required>
                <div class="invalid-feedback">Ingresa la fecha de pago.</div>
              </div>
              <div class="col-12">
                <label class="field-label">Comprobante de pago</label>
                <input type="file" @change="handleFile" ref="archivoInput" class="form-control"
                  accept="image/*,.pdf" required>
                <div class="invalid-feedback">Sube tu comprobante de pago.</div>
              </div>
            </div>
          </section>

          <!-- Botón de acción -->
          <div class="d-grid gap-2 mt-5">
            <button type="submit" class="btn btn--dark register-submit" :disabled="isLoading">
              {{ formData.distancia ? `INSCRIBIRME AL ${formData.distancia}` : 'INSCRIBIRME' }}
            </button>
          </div>

        </div>
      </form>
    </div>

    <AppLoader :show="isLoading" />
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch, onMounted } from 'vue'
import { useToast } from 'vue-toast-notification'
import { db, storage } from '@/firebase/firebase'
import { query, where, getDocs, collection, addDoc, serverTimestamp, updateDoc, doc, runTransaction, limit } from 'firebase/firestore'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import imageCompression from 'browser-image-compression'
import router from '@/router'
import AppLoader from '@/components/AppLoader.vue'

const collectionName = 'corredores_cascadas_diciembre_2026'
const counterCascadasRegisters = 'contador_corredores_cascadas_diciembre_2026'
const storageFolder = 'comprobantes_cascadas_diciembre_2026'

const $toast = useToast()

const archivoComprobante = ref(null)
const archivoInput = ref(null)

const otroGenero = ref('')
const validated = ref(false)
const isLoading = ref(false)

const formCantidadAcom = ref('0')
const formCantidadAcomOtra = ref('')
const acomList = ref([])
const modalidadAcompanantes = ref('dia')

const costoUnitarioAcompanante = computed(() => modalidadAcompanantes.value === 'camping' ? 250 : 150)

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

const formData = reactive({
  distancia: '',
  nombre: '',
  edad: '',
  telefono: '',
  ubicacion: '',
  email: '',
  emergencia: '',
  tallaCamisa: '',
  genero: '',
  aceptaResponsivaMenor: false,
  aceptaDeslinde: false,
  grupo: '',
  pagoMonto: '',
  pagoFecha: '',
  comprobante: null
})

const esMenorDeEdad = computed(() => {
  const edad = parseInt(formData.edad, 10)
  return !isNaN(edad) && edad > 0 && edad < 18
})

// Si deja de ser menor (corrige la edad), no arrastramos un check que ya no aplica
watch(esMenorDeEdad, (esMenor) => {
  if (!esMenor) formData.aceptaResponsivaMenor = false
})

// Genera dinámicamente los campos de cada acompañante según la cantidad elegida
watch(formCantidadAcom, (nuevaCantidad) => {
  acomList.value = []

  if (nuevaCantidad === 'Otra cantidad') {
    formCantidadAcomOtra.value = ''
    return
  }

  for (let i = 0; i < Number(nuevaCantidad); i++) {
    acomList.value.push({ nombre: '', edad: '', telefono: '' })
  }
})

watch(formCantidadAcomOtra, (nuevaCantidadOtra) => {
  acomList.value = []

  const cant = Number(nuevaCantidadOtra)
  if (!cant || cant <= 0) return

  for (let i = 0; i < cant; i++) {
    acomList.value.push({ nombre: '', edad: '', telefono: '' })
  }
})

const handleFile = (e) => {
  const target = e.target

  if (!target.files || target.files.length === 0) {
    archivoComprobante.value = null
    return
  }

  const file = target.files[0]
  const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024

  if (file.size > MAX_FILE_SIZE_BYTES) {
    $toast.error('El archivo seleccionado es demasiado grande. Por favor, elige un archivo de menos de 5 MB.', {
      position: 'top-right',
      duration: 6000
    })
    archivoComprobante.value = null
    if (target) target.value = ''
    return
  }

  archivoComprobante.value = file
}

const handleFileUpload = async (numCorredor, idDoc, archivoComprobante) => {
  if (!archivoComprobante.value) return true

  try {
    const file = await comprimirImagen(archivoComprobante.value)
    const ext = file.name.split('.').pop()
    const safeName = `comprobante_${idDoc}_${numCorredor}.${ext}`

    const formatterNumCorredor = String(numCorredor).padStart(4, '0')
    const path = `${storageFolder}/CorredorNum_${formatterNumCorredor}/${safeName}`
    const refPath = storageRef(storage, path)

    await uploadBytes(refPath, file)
    const url = await getDownloadURL(refPath)

    await updateDoc(doc(db, collectionName, idDoc), {
      comprobanteUrl: url,
      comprobanteError: false
    })
    return true
  } catch (uploadError) {
    await updateDoc(doc(db, collectionName, idDoc), {
      comprobanteUrl: null,
      comprobanteError: true,
      errorSubidaComprobante: uploadError.message
    })

    $toast.warning(
      'Tu registro está listo, pero hubo un detalle al subir la foto de tu comprobante. El staff lo revisará.',
      { position: 'top-right', duration: 8000 }
    )

    return false
  }
}

const submitRegistration = async (event) => {
  validated.value = true
  const formDataEvent = event.target

  if (!formDataEvent.checkValidity()) {
    return
  }

  // Reglas adicionales que no cubre el checkValidity nativo
  if (esMenorDeEdad.value && !formData.aceptaResponsivaMenor) {
    $toast.error('Debes confirmar la entrega de la responsiva para menores de edad.', {
      position: 'top-right',
      duration: 6000
    })
    return
  }

  if (!formData.aceptaDeslinde) {
    $toast.error('Debes aceptar el aviso de riesgo y responsabilidad para inscribirte.', {
      position: 'top-right',
      duration: 6000
    })
    return
  }

  const datosAEnviar = {
    ...formData,
    email: formData.email.trim().toLowerCase(),
    acompanantes: acomList.value,
    numAcompanantes: acomList.value.length,
    modalidadAcompanantes: acomList.value.length > 0 ? modalidadAcompanantes.value : null,
    costoAcompanantes: acomList.value.length * costoUnitarioAcompanante.value
  }

  delete datosAEnviar.comprobante

  if (datosAEnviar.genero === 'Otro' && otroGenero.value.trim() !== '') {
    datosAEnviar.genero = otroGenero.value.trim()
  }

  try {
    isLoading.value = true

    const emailQuery = query(
      collection(db, collectionName),
      where('email', '==', datosAEnviar.email),
      limit(1)
    )

    const emailSnap = await getDocs(emailQuery)

    if (!emailSnap.empty) {
      $toast.error('Este correo electrónico ya se encuentra registrado para la carrera.', {
        position: 'top-right',
        duration: 6000
      })
      isLoading.value = false
      return
    }

    const numeroCorredor = await runTransaction(db, async (transaction) => {
      const contadorRef = doc(db, counterCascadasRegisters, 'contador')
      const contadorSnap = await transaction.get(contadorRef)
      let currentCount = 0

      if (!contadorSnap.exists()) {
        transaction.set(contadorRef, { contadorCompetidores: 1 })
      } else {
        currentCount = contadorSnap.data().contadorCompetidores
      }

      const newCount = currentCount + 1
      transaction.update(contadorRef, { contadorCompetidores: newCount })
      return newCount
    })

    const docRef = await addDoc(collection(db, collectionName), {
      numeroCorredor: numeroCorredor,
      ...datosAEnviar,
      fechaRegistro: serverTimestamp(),
      comprobanteUrl: null,
      pagoConfirmado: false,
      pagoConfirmadoPor: null,
      fechaConfirmacionPago: null
    })

    if (archivoComprobante.value) {
      await handleFileUpload(numeroCorredor, docRef.id, archivoComprobante)
    }

    Object.assign(formData, {
      distancia: '',
      nombre: '',
      edad: '',
      telefono: '',
      ubicacion: '',
      email: '',
      emergencia: '',
      tallaCamisa: '',
      genero: '',
      aceptaResponsivaMenor: false,
      aceptaDeslinde: false,
      grupo: '',
      pagoMonto: '',
      pagoFecha: '',
      comprobante: null
    })

    archivoComprobante.value = null
    if (archivoInput.value) archivoInput.value.value = null
    otroGenero.value = ''
    formCantidadAcom.value = '0'
    formCantidadAcomOtra.value = ''
    acomList.value = []
    modalidadAcompanantes.value = 'dia'

    router.replace({
      name: 'Confirmacion registro cascadas 2026',
      params: { numeroCorredor: String(numeroCorredor) }
    })

    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (error) {
    await reportarError(
      'Registro Reto Entre Cascadas 2026',
      'submitRegistration',
      error,
      {
        email: formData.email,
        nombre: formData.nombre,
        distancia: formData.distancia
      }
    )

    $toast.error('Error al guardar el registro. Intenta de nuevo.', {
      position: 'top-right',
      duration: 5000
    })
  } finally {
    isLoading.value = false
    validated.value = false
  }
}

async function comprimirImagen (file) {
  if (!file || !file.type.includes('image')) return file

  const opciones = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1400,
    useWebWorker: true
  }

  return await imageCompression(file, opciones)
}

const reportarError = async (modulo, funcion, errorOriginal, contexto = {}) => {
  try {
    await addDoc(collection(db, 'logs_errores'), {
      fecha: serverTimestamp(),
      modulo: modulo,
      funcion: funcion,
      error: {
        name: errorOriginal.name || 'Error genérico',
        code: errorOriginal.code || 'N/A',
        message: errorOriginal.message || String(errorOriginal),
        stack: errorOriginal.stack || null
      },
      datosContexto: contexto,
      userAgent: navigator.userAgent
    })
  } catch (logError) {
    console.error('Fallo crítico: No se pudo guardar el log de error')
  }
}

watch(() => formData.genero, () => { validated.value = false })
watch(() => formData.tallaCamisa, () => { validated.value = false })
</script>

<style setup>
@import url('https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@300;400;600;700;800&display=swap');

/* ============================================================
   Hereda los tokens del sitio principal (Reto Entre Cascadas)
   ============================================================ */
.cascadas-register {
  --forest-950: #0d1912;
  --forest-900: #12241a;
  --forest-800: #1b3527;
  --forest-700: #274c37;
  --moss-500: #7f9c5c;
  --moss-400: #a2bd82;
  --water-600: #2f5f66;
  --gold-500: #c9a04a;
  --paper-050: #faf7ee;
  --paper-100: #f1ead9;
  --ink-900: #14231a;

  --font-display: 'Anton', 'Arial Narrow', sans-serif;
  --font-body: 'Inter', sans-serif;

  background: var(--paper-050);
  font-family: var(--font-body);
  color: var(--ink-900);
  min-height: 100vh;
  padding-bottom: 4rem;
}

.cascadas-register :is(h1, h4) { font-family: var(--font-display); font-weight: 400; margin: 0; }

/* ---------- hero band ---------- */
.register-hero {
  background: linear-gradient(180deg, var(--forest-900) 0%, var(--forest-950) 100%);
  color: #fff;
  text-align: center;
  padding: 3.5rem 1.5rem 6.5rem;
}
.register-hero__brand { display: block; font-weight: 300; letter-spacing: 8px; font-size: 1rem; margin-bottom: 1rem; opacity: .85; }
.register-hero__title { font-size: clamp(2rem, 6vw, 3rem); letter-spacing: 1px; }
.register-hero__sub { font-weight: 300; color: var(--paper-100); margin-top: .75rem; letter-spacing: .5px; }

/* ---------- ticket / form container ---------- */
.register-wrap { max-width: 760px; margin: -4rem auto 0; padding: 0 1.25rem; position: relative; z-index: 2; }
.register-ticket {
  position: relative;
  background: #fff;
  border-radius: 24px;
  padding: 2.75rem 2.25rem;
  box-shadow: 0 30px 60px rgba(13,25,18,.15);
  border: 1px solid rgba(20,35,26,.06);
}
.register-ticket__notch { position: absolute; top: 6.4rem; width: 30px; height: 30px; border-radius: 50%; background: var(--paper-050); display: none; }
@media (min-width: 640px) {
  .register-ticket__notch { display: block; }
  .register-ticket__notch--left { left: -15px; }
  .register-ticket__notch--right { right: -15px; }
}

/* ---------- labels & shared text ---------- */
.field-label {
  display: block;
  font-size: .78rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--forest-700);
  margin-bottom: .4rem;
}
.field-label--center { text-align: center; margin-bottom: 1.25rem; }

.section-title {
  font-family: var(--font-body);
  font-weight: 800;
  font-size: 1.05rem;
  letter-spacing: .5px;
  text-transform: uppercase;
  color: var(--forest-950);
  border-left: 4px solid var(--moss-500);
  padding-left: 12px;
  margin-bottom: 1.5rem;
}
.section-divider { border-top: 1px solid rgba(20,35,26,.08); }

/* ---------- acompañantes ---------- */
.companion-intro { font-size: .9rem; color: var(--forest-700); margin: -0.5rem 0 1rem; }

.companion-prices {
  display: flex;
  flex-wrap: wrap;
  gap: .6rem;
  margin-bottom: 1.5rem;
}
.companion-prices__item {
  background: var(--paper-100);
  border-radius: 12px;
  padding: 10px 16px;
  font-size: .85rem;
  color: var(--forest-900);
}
.companion-prices__item strong { font-family: var(--font-display); color: var(--forest-950); font-size: 1rem; margin: 0 2px 0 4px; }
.companion-prices__item small { opacity: .6; }

.companion-mode-toggle { display: flex; flex-wrap: wrap; gap: .75rem; }
.companion-mode-toggle__btn {
  flex: 1 1 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 12px 16px;
  border: 2px solid rgba(20,35,26,.15);
  border-radius: 14px;
  cursor: pointer;
  font-size: .88rem;
  font-weight: 700;
  color: var(--forest-900);
  text-align: center;
  transition: all .2s ease;
}
.companion-mode-toggle__btn span { font-weight: 600; font-size: .78rem; opacity: .7; }
.companion-mode-toggle .btn-check:checked + .companion-mode-toggle__btn {
  background: var(--forest-950);
  border-color: var(--forest-950);
  color: #fff;
}
.companion-mode-toggle .btn-check:checked + .companion-mode-toggle__btn span { opacity: .85; }

.companion-total {
  margin-top: 1.25rem;
  background: var(--paper-100);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: .9rem;
  text-align: center;
  color: var(--forest-900);
}
.companion-total strong { color: var(--forest-950); }
.companion-card {
  background: var(--paper-050);
  border: 1px solid rgba(20,35,26,.08);
  border-radius: 16px;
  padding: 1.5rem;
  margin-top: 1.25rem;
}
.companion-card__index {
  display: inline-block;
  font-size: .72rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--moss-500);
  margin-bottom: 1rem;
}
.companion-hint { font-size: .82rem; color: var(--forest-700); margin: .5rem 0 0; }

/* ---------- distance toggle ---------- */
.distance-toggle {
  display: flex;
  gap: .75rem;
  justify-content: center;
  flex-wrap: wrap;
}
.distance-toggle__btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 150px;
  padding: 16px 26px;
  border: 2px solid var(--forest-800);
  border-radius: 16px;
  cursor: pointer;
  color: var(--forest-900);
  transition: all .25s ease;
}
.distance-toggle__km { font-family: var(--font-display); font-size: 1.6rem; letter-spacing: 1px; }
.distance-toggle__time { font-size: .75rem; letter-spacing: .5px; opacity: .7; }
.btn-check { position: absolute; opacity: 0; pointer-events: none; }
.btn-check:checked + .distance-toggle__btn {
  background: var(--forest-950);
  border-color: var(--forest-950);
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(13,25,18,.2);
}
.btn-check:checked + .distance-toggle__btn .distance-toggle__time { opacity: .8; }

/* ---------- gender / category preview ---------- */
.gender-group { display: flex; flex-wrap: wrap; gap: 1.25rem; margin-top: .25rem; }
.category-preview {
  margin-top: 1.5rem;
  background: var(--paper-100);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: .9rem;
  text-align: center;
  color: var(--forest-900);
}
.category-preview strong { color: var(--forest-950); }

/* ---------- minor / responsiva box ---------- */
.minor-box {
  background: rgba(201,160,74,.08);
  border: 1px solid rgba(201,160,74,.35);
  border-radius: 16px;
  padding: 1.5rem 1.75rem;
  margin: 0 0 2rem;
}
.minor-box__tag {
  display: inline-block;
  background: var(--gold-500);
  color: #3a2c05;
  font-size: .68rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 999px;
  margin-bottom: .75rem;
}
.minor-box__title { font-size: 1.2rem; margin-bottom: .5rem; color: var(--forest-950); }
.minor-box p { font-size: .92rem; color: var(--ink-900); margin-bottom: .75rem; }
.minor-box__link { display: inline-block; font-weight: 800; color: var(--water-600); text-decoration: none; font-size: .9rem; }
.minor-box__link:hover { text-decoration: underline; }

/* ---------- waiver / deslinde box ---------- */
.waiver-box {
  background: var(--forest-950);
  color: var(--paper-100);
  border-radius: 16px;
  padding: 1.75rem 1.75rem 1.5rem;
  margin: 0 0 2.5rem;
}
.waiver-box__tag {
  display: inline-block;
  background: rgba(255,255,255,.12);
  border: 1px solid rgba(255,255,255,.25);
  font-size: .68rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 999px;
  margin-bottom: .75rem;
  color: #fff;
}
.waiver-box__title { font-size: 1.2rem; color: #fff; margin-bottom: .5rem; }
.waiver-box p { font-size: .9rem; opacity: .85; margin-bottom: 1rem; }
.waiver-box .form-check-label { font-size: .85rem; opacity: .9; }
.waiver-box .invalid-feedback { color: #ffb4b4; }

/* ---------- generic bootstrap overrides ---------- */
.cascadas-register .form-control,
.cascadas-register .form-select {
  border-radius: 10px;
  border: 1px solid rgba(20,35,26,.15);
  padding: 10px 14px;
  font-family: var(--font-body);
}
.cascadas-register .form-control:focus,
.cascadas-register .form-select:focus {
  border-color: var(--moss-500);
  box-shadow: 0 0 0 0.2rem rgba(127,156,92,.25);
}
.cascadas-register .form-check-input:checked {
  background-color: var(--forest-950);
  border-color: var(--forest-950);
}
.cascadas-register .form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(127,156,92,.25);
}
.cascadas-register .invalid-feedback { display: none; font-size: .8rem; }
.cascadas-register .was-validated :invalid ~ .invalid-feedback,
.cascadas-register .form-check-input.was-validated:invalid ~ .invalid-feedback { display: block; }

.register-submit {
  width: 100%;
  padding: 18px;
  font-size: 1rem;
}
.register-submit:disabled { opacity: .6; cursor: not-allowed; }

/* ---------- fix: el toast quedaba oculto detrás del navbar ---------- */
.v-toast,
.v-toast__item {
  z-index: 2147483647 !important;
}

.fade-enter-active, .fade-leave-active { transition: opacity .3s ease, transform .3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(-10px); }

@media (max-width: 560px) {
  .register-wrap { margin-top: -3rem; }
  .register-ticket { padding: 2rem 1.4rem; }
}
</style>
